import { useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, usePathname, useSearchParams } from 'src/routes/hooks';

import { useUserAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function CompleteProfileGuard({ children }: Props) {
  const router = useRouter();

  const pathname = usePathname();

  const searchParams = useSearchParams();

  const { authenticated, isCompleteProfile } = useUserAuthContext();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams],
  );

  useEffect(() => {
    if (
      !isCompleteProfile &&
      pathname !== paths.userAuth.completeProfile &&
      authenticated
    ) {
      const completeProfilePath = paths.userAuth.completeProfile;

      const href = `${completeProfilePath}?${createQueryString(
        'returnTo',
        pathname,
      )}`;

      router.replace(href);
      return;
    }
  }, [isCompleteProfile, pathname, router, authenticated]);

  return children;
}
